import './Overlay-aeb12fc3.css';

var classes = {"Overlay":"prc-Overlay-Overlay-dVyJl"};

export { classes as default };
